export default "__VITE_ASSET__t7Vok$vO__"